import { GenericCategory } from '../generic-category';
import { GenericProduct, GenericEffect, GenericPriceOption } from '../generic-product';
import { transformCategory, transformEffects } from '../generic-product/transformers';
import { getDefaultProductImage } from '../generic-product/utils';
import { valueOrNull } from '../helpers';

import { MarketplaceProduct, MarketplaceProductOption } from './data.types';

export class GenericMarketplaceProduct extends GenericProduct<MarketplaceProduct> {
  readonly image: string | null;
  readonly defaultImage: string;
  readonly category: GenericCategory | null;
  readonly effects: GenericEffect[];
  readonly options: GenericPriceOption[];

  constructor(data: MarketplaceProduct, options: MarketplaceProductOption) {
    super(data);

    const { category, effects, image } = data;

    this.effects = transformEffects(effects);
    this.category = transformCategory(category);
    this.defaultImage = getDefaultProductImage(this.category, this.strainType);
    this.image = valueOrNull(image);
    this.options = options ?? [];
  }

  static isinstance(instance: unknown): instance is GenericMarketplaceProduct {
    return instance instanceof GenericMarketplaceProduct;
  }

  get lowestPrice(): number {
    const lowestOptions = this.options.reduce((prev, curr) => (prev.price < curr.price ? prev : curr), {
      price: Infinity,
    });

    return lowestOptions.price;
  }
}
